/* eslint-disable consistent-this */
/* eslint-disable object-shorthand */
import {NextRouter} from "next/router";

const functions = {
	bccard: function (size) {
		const router = this;
		const url = "https://web.paybooc.co.kr/static/assets/etc/java/cross_resize.html?height=";

		const iframe: HTMLFormElement = document.querySelector("#iframePartner");
		iframe.contentWindow.location.replace(`${url}${size + 50}`);
	},
	gmarket: function (size) {
		const router = this;
		const form: HTMLFormElement = document.querySelector("#iframePartnerForm");
		const fromHeight: HTMLInputElement = form.querySelector("[name=h]");
		form.setAttribute(
			"action",
			router.query?.SITE_ID === "G"
				? "https://gtour.gmarket.co.kr/TourJaehu/IframeResize"
				: "https://gtour.gmarket.co.kr/TourJaehu/IframeResize",
		);
		fromHeight.value = `${size + 150}`;
		form.submit();
	},
};

function production(router: NextRouter) {
	const partnerName = (router.query?.$partnerName as string) || "gmarket";
	return functions[partnerName].bind(router);
}

export default production;
